// removed by extract-text-webpack-plugin
module.exports = {"homeContainer":"homeContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home.css
// module id = 613
// module chunks = 0